import React from 'react'
import Lottie from 'react-lottie'

import useLongPress from '../../hooks/useLongPress'
import { LottieJSON } from '../../utils/links'

type LottiePlayerProps = {
    handleLongPressProgressBar(): void
    handleClickProgressBar(): void
    startAnimation: boolean
    firmLogo: string
}

export default function LottiePlayer({
    startAnimation,
    handleLongPressProgressBar,
    handleClickProgressBar,
    firmLogo,
}: LottiePlayerProps): JSX.Element {
    const defaultOptions = {
        shouldPreventDefault: true,
        delay: 2000,
    }

    const { start, clear, startTouch } = useLongPress(
        handleLongPressProgressBar,
        handleClickProgressBar,
        defaultOptions
    )

    return (
        <div className="lottie-content">
            {startAnimation ? (
                <>
                    <div id="rocket-opening-desktop">
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={{
                                loop: false,
                                autoplay: true,
                                animationData: LottieJSON.RocketOpening,
                                renderer: 'svg',
                                assetsPath: firmLogo,
                            }}
                        ></Lottie>
                    </div>
                    <div id="rocket-opening-640">
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={{
                                loop: false,
                                autoplay: true,
                                animationData: LottieJSON.RocketOpening_640,
                                assetsPath: firmLogo,
                                renderer: 'svg',
                            }}
                        ></Lottie>
                    </div>
                </>
            ) : (
                <div className="lottie-add-fuel">
                    <div id="rocket-add-fuel">
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={{
                                loop: true,
                                autoplay: true,
                                animationData: LottieJSON.RocketLoop,
                                renderer: 'svg',
                                assetsPath: firmLogo,
                            }}
                        ></Lottie>
                    </div>
                    <div className="lottie-add-fuel-btn-container">
                        <button
                            className="lottie-content-btn"
                            onMouseDown={(e) => start(e)}
                            onTouchStart={(e) => start(e)}
                            onMouseUp={(e) => clear(e)}
                            onMouseLeave={(e) => clear(e)}
                            onTouchEnd={(e) => clear(e)}
                        >
                            <div className="progress">
                                <h6>长按以填满燃料 准备启航！</h6>
                                <div className={startTouch ? 'forward' : ''}></div>
                            </div>
                            <Lottie
                                isClickToPauseDisabled={true}
                                options={{
                                    loop: true,
                                    autoplay: true,
                                    animationData: LottieJSON.hand,
                                    renderer: 'svg',
                                }}
                                id="rocket-hand"
                            ></Lottie>
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
